import DutyStatusLog from "../model/DutyStatusLog";
import { formatVerifyDateTimeToString } from "hos-tools";
import { dstCalculator } from "./date";

/**
 * Decides whether a "continued from previous day" placeholder should be displayed as certified.
 *
 * The placeholder is certified when at least one Certify log for its day was made after the source
 * log's last edit, and the source log has no pending requested edit. Any such Certify log certifies
 * the placeholder, even if other Certify logs for the same day pre-date the edit.
 *
 * Shared by the in-window sync (`HosSync.updatePlaceholderProperties`) and the historical day
 * loader so both paths agree on what a certified placeholder looks like.
 *
 * @param sourceLog - The log whose status carries into the placeholder's day.
 * @param placeholderDateTime - Start of the placeholder's day.
 * @param certLogs - Certify logs to match against; those for other days are ignored.
 */
export function isPlaceholderCertified(sourceLog: DutyStatusLog, placeholderDateTime: Date, certLogs: DutyStatusLog[]): boolean {
    if (sourceLog.hasPendingRequest()) {
        return false;
    }

    const placeholderDay = formatVerifyDateTimeToString(placeholderDateTime.toISOString(), dstCalculator.toLocalDateTime);
    const isEditedAfterCertify = (certifyLog: DutyStatusLog) => !!sourceLog.editDateTime && sourceLog.editDateTime > certifyLog.dateTime;

    return certLogs.some(certifyLog =>
        !!certifyLog.verifyDateTime
        && formatVerifyDateTimeToString(certifyLog.verifyDateTime, dstCalculator.toLocalDateTime) === placeholderDay
        && !isEditedAfterCertify(certifyLog));
}
